import { NavigationOptions, NavigationClient } from "@azure/msal-browser";
import { Router } from "vue-router";

const MSAL_AUTH_PARAMS = ["state", "code", "client_info", "session_state"];

/**
 * Override MSAL route navigation
 */
export class VueNavigationClient extends NavigationClient {
  private readonly router: Router;

  constructor(router: Router) {
    super();
    this.router = router;
  }

  /**
   * Only called during redirects
   */
  navigateExternal(url: string, options: NavigationOptions): Promise<boolean> {
    return super.navigateExternal(url, options);
  }

  /**
   * Only called during popup completion
   */
  async navigateInternal(
    url: string,
    options: NavigationOptions,
  ): Promise<boolean> {
    // For hash-history routes, preserve in-app route hashes (e.g. "#/finder")
    // but drop MSAL auth fragments (e.g. "#code=...&state=...").
    let path = "/";
    try {
      const u = new URL(url, location.origin);

      const routeHash = u.hash.startsWith("#/") ? u.hash.substring(1) : "";
      if (routeHash) {
        const [hashPathRaw, hashQueryRaw] = routeHash.split("?");
        const hashPath = hashPathRaw || "/";
        if (!hashQueryRaw) {
          path = hashPath;
        } else {
          const params = new URLSearchParams(hashQueryRaw);
          MSAL_AUTH_PARAMS.forEach((key) => params.delete(key));
          const cleaned = params.toString();
          path = cleaned ? `${hashPath}?${cleaned}` : hashPath;
        }
      } else if (u.hash.includes("state=") || u.hash.includes("code=")) {
        path = "/";
      } else {
        path = u.pathname + u.search || "/";
      }
    } catch {
      // Fallback to previous behavior
      const replaced = url.replace(location.origin, "");
      path = replaced || "/";
    }
    if (options.noHistory) {
      await this.router.replace(path);
    } else {
      await this.router.push(path);
    }
    return true;
  }
}
